import React from 'react';
import { motion } from 'framer-motion';
import { Users, Award, TrendingUp, MoreHorizontal } from 'lucide-react';
interface Message {
  text: string;
  isHighlight?: boolean;
}
interface Testimonial {
  author: string;
  location: string;
  time: string;
  avatar: string;
  messages: Message[];
  resultBadge: string;
}
const testimonials: Testimonial[] = [{
  author: 'Gabriela',
  location: 'Mar del Plata',
  time: '20:30',
  avatar: 'https://cdn.magicpatterns.com/uploads/7R1nqBiDMzMj21eGKC3d1U/Chegando_em_Saint_Tropez.jpg',
  messages: [{
    text: 'arranqué sin saber nada y sin laburo, practicamente empecé de cero'
  }, {
    text: 'el finde pasado hice $32.000 desde casa!'
  }],
  resultBadge: '+$32.000 en un finde'
}, {
  author: 'Flor',
  location: 'CABA',
  time: '17:45',
  avatar: 'https://cdn.magicpatterns.com/uploads/qG4vQM6Xs8qm5EsBQ6fjm2/Federica_Buccoli_on_Reels___Pomplamoose_·_Oh….jpg',
  messages: [{
    text: 'sigo sin poder creerlo!! 😍'
  }, {
    text: 'esta semana saqué 20 focaccias! me estoy quedando sin lugar'
  }],
  resultBadge: '💰 $20.000 en una semana'
}, {
  author: 'Laura',
  location: 'Córdoba',
  time: '14:22',
  avatar: 'https://cdn.magicpatterns.com/uploads/9UChvx66EqKHf2rN6zUUEA/Focaccia_art_is_latest_baking_trend_taking_over_social_media.jpg',
  messages: [{
    text: 'recuperé TODO lo que invertí en 3 días 🙌'
  }, {
    text: 'ahora tengo pedidos fijos todos los sábados, no doy abasto'
  }],
  resultBadge: 'Inversión recuperada en 3 días'
}, {
  author: 'Sofía',
  location: 'Mendoza',
  time: '09:18',
  avatar: 'https://cdn.magicpatterns.com/uploads/f6Y8Q9Cm1tfK24Gc3mNEq9/La_receta_de_focaccia_casera_que_siempre_sale_bien.jpg',
  messages: [{
    text: 'con $5.000 de ingredientes arranqué'
  }, {
    text: 'el primer finde facturé $18.000, no lo podía creer 🔥'
  }],
  resultBadge: '$18.000 en el primer finde'
}];
const stats = [{
  icon: Users,
  label: '+200 alumnas'
}, {
  icon: TrendingUp,
  label: 'Resultados reales'
}, {
  icon: Award,
  label: 'Método probado'
}];
export function SocialProof() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal relative overflow-hidden" data-id="element-192">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,rgba(212,168,83,0.04)_0%,transparent_50%)]" data-id="element-193" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-194">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-195">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-196">
            Mujeres que ya están{' '}
            <span className="text-gold italic font-normal" data-id="element-197">
              generando ingresos
            </span>{' '}
            con focaccias
          </h2>
          <p className="text-lg text-cream-muted max-w-xl mx-auto" data-id="element-198">
            Resultados reales en días, no en meses.
          </p>
        </motion.div>

        {/* Stats badges */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-wrap justify-center gap-3 sm:gap-5 mb-14" data-id="element-199">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 bg-warmBrown/40 border border-gold/20 px-5 py-2.5 rounded-full" data-id="element-200">
              <stat.icon className="w-5 h-5 text-gold" data-id="element-201" />
              <span className="text-cream font-medium text-sm sm:text-base" data-id="element-202">
                {stat.label}
              </span>
            </div>)}
        </motion.div>

        {/* Testimonials grid */}
        <div className="grid sm:grid-cols-2 gap-6 lg:gap-8" data-id="element-203">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-204">
              {/* Phone frame */}
              <div className="bg-[#0b0b0b] border border-[#333] rounded-[1.75rem] overflow-hidden shadow-[0_8px_40px_rgba(0,0,0,0.5)]" data-id="element-205">
                {/* Status bar */}
                <div className="bg-[#075E54] px-4 pt-2.5 pb-0" data-id="element-206">
                  <div className="flex items-center justify-between mb-2" data-id="element-207">
                    <div className="flex gap-[3px]" data-id="element-208">
                      <div className="w-[5px] h-[5px] rounded-full bg-white/40" data-id="element-209" />
                      <div className="w-[5px] h-[5px] rounded-full bg-white/40" data-id="element-210" />
                      <div className="w-[5px] h-[5px] rounded-full bg-white/40" data-id="element-211" />
                    </div>
                    <span className="text-white/60 text-[11px] font-medium tabular-nums" data-id="element-212">
                      {t.time}
                    </span>
                    <div className="flex items-center gap-1" data-id="element-213">
                      <div className="w-3 h-[5px] rounded-sm bg-white/40" data-id="element-214" />
                      <div className="w-[5px] h-[5px] rounded-full bg-white/40" data-id="element-215" />
                    </div>
                  </div>
                </div>

                {/* WhatsApp header */}
                <div className="bg-[#075E54] px-4 pb-3 flex items-center justify-between" data-id="element-216">
                  <div className="flex items-center gap-3" data-id="element-217">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-500 flex-shrink-0 ring-2 ring-white/10" data-id="element-218">
                      <img src={t.avatar} alt={t.author} className="w-full h-full object-cover" data-id="element-219" />
                    </div>
                    <div data-id="element-220">
                      <div className="text-white font-semibold text-[15px] leading-tight" data-id="element-221">
                        {t.author}
                      </div>
                      <div className="text-white/60 text-[12px]" data-id="element-222">
                        {t.location}
                      </div>
                    </div>
                  </div>
                  <MoreHorizontal className="w-5 h-5 text-white/50" data-id="element-223" />
                </div>

                {/* Chat area */}
                <div className="p-3 pb-2 min-h-[200px] flex flex-col gap-2 relative" style={{
              backgroundColor: '#0b141a',
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.02'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
            }} data-id="element-224">
                  {/* Incoming messages */}
                  {t.messages.map((msg, mi) => <div key={mi} className="flex justify-start" data-id="element-225">
                      <div className="bg-[#202c33] rounded-lg rounded-tl-sm px-3 py-2 max-w-[85%] relative shadow-sm" data-id="element-226">
                        <p className="text-[#e9edef] text-[14px] leading-relaxed pr-12" data-id="element-227">
                          {msg.text}
                        </p>
                        <span className="absolute bottom-1 right-2 text-[#8696a0] text-[10px] tabular-nums flex items-center gap-1" data-id="element-228">
                          {t.time}
                          <svg width="16" height="11" viewBox="0 0 16 11" className="text-[#53bdeb]" data-id="element-229">
                            <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.336.153.457.457 0 0 0 0 .611l2.357 2.547a.463.463 0 0 0 .336.178h.025a.427.427 0 0 0 .331-.178l6.509-8.026a.392.392 0 0 0 0-.534v-.135z" fill="currentColor" data-id="element-230" />
                            <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.61.756 1.47 1.59a.463.463 0 0 0 .336.178h.025a.427.427 0 0 0 .331-.178l6.509-8.026a.392.392 0 0 0 .014-.534v-.2z" fill="currentColor" data-id="element-231" />
                          </svg>
                        </span>
                      </div>
                    </div>)}

                  {/* Outgoing highlight bubble (green, right-aligned) */}
                  <div className="flex justify-end mt-1" data-id="element-232">
                    <div className="bg-[#005c4b] rounded-lg rounded-tr-sm px-3 py-2 max-w-[80%] relative shadow-sm" data-id="element-233">
                      <p className="text-white text-[14px] font-bold pr-12" data-id="element-234">
                        {t.resultBadge}
                      </p>
                      <span className="absolute bottom-1 right-2 text-white/50 text-[10px] tabular-nums flex items-center gap-1" data-id="element-235">
                        {t.time}
                        <svg width="16" height="11" viewBox="0 0 16 11" className="text-[#53bdeb]" data-id="element-236">
                          <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.336.153.457.457 0 0 0 0 .611l2.357 2.547a.463.463 0 0 0 .336.178h.025a.427.427 0 0 0 .331-.178l6.509-8.026a.392.392 0 0 0 0-.534v-.135z" fill="currentColor" data-id="element-237" />
                          <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.61.756 1.47 1.59a.463.463 0 0 0 .336.178h.025a.427.427 0 0 0 .331-.178l6.509-8.026a.392.392 0 0 0 .014-.534v-.2z" fill="currentColor" data-id="element-238" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>

                {/* Input bar */}
                <div className="bg-[#1f2c34] px-3 py-2.5 flex items-center gap-2" data-id="element-239">
                  <div className="flex-1 bg-[#2a3942] rounded-full px-4 py-2" data-id="element-240">
                    <span className="text-[#8696a0] text-[13px]" data-id="element-241">Mensaje</span>
                  </div>
                  <div className="w-9 h-9 rounded-full bg-[#00a884] flex items-center justify-center flex-shrink-0" data-id="element-242">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="text-white" data-id="element-243">
                      <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-244" />
                      <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-245" />
                    </svg>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}